import { lazy } from "react";
import AddBank from "./Bank/AddBank";
import BankLists from "./Bank/BankLists";

import MerchantList from "./Merchant/MerchantList";
import AllReq from "./Payments/AllReq";
import ApprovedReq from "./Payments/ApprovedReq";
import DeclinedReq from "./Payments/DeclinedReq";
import PendingReq from "./Payments/PendingReq";
import ManualCRDR from "./Payments/ManualCRDR";
import TransactionHistory from "./Transaction-history/TransactionHistory";
import AddReq from "./Payments/AddReq";
import MerchantAddReq from "./Payments/MerchantAddReq";

import DistReq from "./Payments/DistReq";
import BookingHistory from "./Flight/Booking";

const Dashboard = lazy(() => import("./Dashboard/Dashboard"));

const distributorRoutes = [
  {
    path: "/distributor/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/distributor/merchants",
    element: <MerchantList />,
  },

  {
    path: "/distributor/bank/bank-lists",
    element: <BankLists />,
  },
  {
    path: "/distributor/bank/add",
    element: <AddBank />,
  },
  {
    path: "/distributor/payments/all-req",
    element: <AllReq />,
  },
  {
    path: "/distributor/payments/pending-req",
    element: <PendingReq />,
  },
  {
    path: "/distributor/payments/approved-req",
    element: <ApprovedReq />,
  },
  {
    path: "/distributor/payments/declined-req",
    element: <DeclinedReq />,
  },
  {
    path: "/distributor/payments/manual-cr-dr",
    element: <ManualCRDR />,
  },
  {
    path: "/distributor/payments/members-add-req",
    element: <MerchantAddReq />,
  },
  {
    path: "/distributor/payments/add-req",
    element: <AddReq />,
  },
  {
    path: "/distributor/transaction-history",
    element: <TransactionHistory />,
  },

  {
    path: "/distributor/payments/distributor-requisition",
    element: <DistReq />,
  },
  {
    path: "/distributor/flight/booking-history",
    element: <BookingHistory />,
  },
];

export default distributorRoutes;
